import { ScaleLinear } from 'd3'
import { formatSwissDate } from './formatSwissDate'

export const XTicks = ({
  data,
  x,
  y,
  locale,
  hideLabels
}: {
  data: xTickDataType
  x: ScaleLinear<number, number, never>
  y: ScaleLinear<number, number>
  locale: 'de' | 'fr'
  hideLabels: boolean
}) => {
  const textOffsetY = 17
  return (
    <>
      {/* {data.lines &&
        data.lines.map((t, i) => {
          return (
            <line
              key={i}
              y1={y.range()[1]}
              y2={y.range()[0]}
              x1={x(new Date(t))}
              x2={x(new Date(t))}
              className='tickline'
            />
          )
        })} */}
      {data.text && !hideLabels &&
        data.text.map((t, i) => {
          return (
            <text
              key={i}
              x={x(new Date(t))}
              y={y.range()[0] + textOffsetY}
              className='ticktext'
              textAnchor={i === 0 ? 'start' : 'end'}
            >
              {window.innerWidth < 600
                ? formatSwissDate(t, 'short_chart', locale)
                : formatSwissDate(t, 'short_chart', locale)}
            </text>
          )
        })}
    </>
  )
}
